import { Cookies } from 'react-cookie';

import { MapLocation } from 'api/traps/types';
import axiosInterceptor from 'api/interceptor/axiosClient';

export const getLocationsOnMap = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`v1/floor-plans/${slug}/locations/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as MapLocation[];
};
